export const POPUP_WIDTH = 300;
export const POPUP_WIDTH_HALF = POPUP_WIDTH / 2;
export const POPUP_HEIGHT = 370;
export const POPUP_HEIGHT_HALF = POPUP_HEIGHT / 2;

export const POPUP_DEFAULT_OPTIONS = {
  closeButton: false,
};
